/**
 * True when both objects expose the same own keys with identical (`Object.is`) values. Recognises
 * a fresh shallow clone of an unchanged object without comparing deeply.
 */
const hasSameOwnValues = (left, right) => {
  if (left === right) {
    return true;
  }

  if (!left || !right || typeof left !== 'object' || typeof right !== 'object') {
    return false;
  }

  const leftKeys = Object.keys(left);
  if (leftKeys.length !== Object.keys(right).length) {
    return false;
  }

  return leftKeys.every((key) => Object.prototype.hasOwnProperty.call(right, key) && Object.is(left[key], right[key]));
};

export default hasSameOwnValues;
